import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Auth() {
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "login" ? "login" : "signup");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const next = params.get("next") || "/studio";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !password.trim()) { setError("Completa tu correo y contraseña para continuar."); return; }
    if (mode === "signup" && password.length < 6) { setError("La contraseña necesita al menos 6 caracteres."); return; }
    setLoading(true);
    const res = await (mode === "login" ? login : register)(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate(next); else setError(res.error);
  };

  return (
    <div className="auth" data-mode={mode}>
      <aside className="auth-art aurora">
        <button className="logo" style={{ color: "#fff" }} onClick={() => navigate("/")}>
          <span className="mark" style={{ background: "#fff" }} aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1C3B73" strokeWidth="1.6" strokeLinecap="round"><path d="M20 3c-6 1-11 6-13 13l-2 5" /><path d="M20 3c0 7-5 12-12 13" /><path d="M9 12h5" /></svg>
          </span>Jarvis <em>Editorial</em>
        </button>
        <p className="quote-big">«Escribir fue lo difícil. <em>Publicar no debería serlo.</em>»</p>
        <ul className="benefits">
          <li><span className="b">1</span>Informe editorial gratis en menos de un minuto</li>
          <li><span className="b">∞</span>Revisiones sin límite, a tu ritmo</li>
          <li><span className="b">€</span>Pagas solo al descargar tu libro</li>
        </ul>
      </aside>

      <div className="auth-form">
        <button className="back" onClick={() => navigate("/")}>← Volver a la web</button>
        <div className="auth-box">
          <div className="authseg" data-mode={mode} role="tablist" aria-label="Tipo de acceso">
            <span className="thumb" aria-hidden="true" />
            <button role="tab" aria-selected={mode === "signup"} data-testid="auth-tab-signup" onClick={() => { setMode("signup"); setError(""); }}>Crear cuenta</button>
            <button role="tab" aria-selected={mode === "login"} data-testid="auth-tab-login" onClick={() => { setMode("login"); setError(""); }}>Entrar</button>
          </div>

          <span className="eyebrow">{mode === "signup" ? "Paso 1 de 2 · tu cuenta" : "Acceso"}</span>
          <h1>{mode === "signup" ? "Empieza tu libro" : "Entra a tu estudio"}</h1>
          <p className="sub">{mode === "signup" ? "En el siguiente paso subes tu manuscrito." : "Tu trabajo sigue aquí, te esperamos."}</p>

          <form onSubmit={submit} noValidate>
            <label className="afield">
              <label>Correo</label>
              <div className="ainp"><input type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" autoComplete="email" /></div>
            </label>
            <label className="afield">
              <label>Contraseña</label>
              <div className="ainp">
                <input type={show ? "text" : "password"} data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres" autoComplete={mode === "signup" ? "new-password" : "current-password"} />
                <button className="eye" type="button" aria-label="Mostrar contraseña" onClick={() => setShow((s) => !s)}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>
                </button>
              </div>
            </label>
            {error && <div className="aerr" data-testid="auth-error">⚠ {error}</div>}
            <button className="btn cta btn-full" type="submit" data-testid="login-submit-btn" disabled={loading}>
              <span className="cta-halo" aria-hidden="true" />{loading ? "Un momento…" : mode === "signup" ? "Crear cuenta y subir mi manuscrito" : "Entrar a mi estudio"}
            </button>
          </form>
          <p className="fine">{mode === "signup" ? "Gratis hasta la entrega · sin tarjeta" : "Jarvis Editorial · en español"}</p>
        </div>
      </div>
    </div>
  );
}
